export const getEddmLineItemPrice = (templateOptions) => {
    return (
    templateOptions.options.find((o) => o.dev_key === "address_lists")?.flatPrice?.[6] ?
       (templateOptions.options.find((o) => o.dev_key === "address_lists").flatPrice?.[6] * -1) : (-1 * 0.06))
};